import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStatusBarContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginTop: 'auto',
  marginLeft: theme.spacing(-4),
  marginRight: theme.spacing(-4),
  marginBottom: theme.spacing(-4),
  padding: theme.spacing(0, 4),
  backgroundColor: theme.palette.background.blue,
  borderBottomLeftRadius: theme.customShape.borderRadius3XL,
  borderBottomRightRadius: theme.customShape.borderRadius3XL,

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6),
  },

  [theme.breakpoints.up('lg')]: {
    borderBottomRightRadius: 0,
  },
}));

export const StyledStatusBarItem = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  justifyContent: 'center',
  gap: 0,
  borderRight: `1px solid ${theme.palette.background.paper}`,
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),

  '&:first-child': {
    flex: 1,
  },

  '&:last-child': {
    borderRight: 'none',
    paddingRight: 0,
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const StyledStatusBarLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(10),
  lineHeight: 1.2,
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightRegular,
  whiteSpace: 'nowrap',

  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(11),
  },
}));

export const StyledStatusBarValue = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(10),
  lineHeight: 1.2,
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'nowrap',

  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(11),
  },
}));
